import {
    SimOnlyOffer,
    TariffWithHardwareOffer,
} from '@vfde-sails/glados-v2';
import {
    RedplusTariff,
    RedTariff,
    SalesChannel,
    SALESCHANNEL_FAMILY_FRIENDS,
    SALESCHANNEL_SOHO,
    YoungTariff,
} from '@vfde-sails/constants';

/**
 * App flow type
 */
export enum AppFlow {
    Standalone = 'standalone',
    Vvl = 'invvl',
}

/**
 * Raw app state
 */
export interface InitialState {
    /**
     * Available subscription IDs
     */
    availableSubscriptionIds: RedplusTariff[];
    /**
     * Customer configuration
     */
    customerConfig: {
        /**
         * The customer can purchase a Red+ card as standalone addition to their current tariff or as part of the VVL
         * flow
         */
        flow: AppFlow;
        /**
         * Sales channel in case of VVL flow
         */
        salesChannel: Exclude<SalesChannel, typeof SALESCHANNEL_SOHO | typeof SALESCHANNEL_FAMILY_FRIENDS | typeof SALESCHANNEL_SOHO>;
        /**
         * Active subscription ID in case of VVL flow
         */
        activeSubscriptionId: RedTariff | YoungTariff | null;
        /**
         * Selected Redplus subscription
         */
        selectedRedplusId: RedplusTariff | null;
        /**
         * Atomic ID
         */
        atomicId: string | null;
        /**
         * In case the customer is in VVL flow, they can be xsell eligible or not
         */
        isXSellEligible: boolean;
        /**
         * Cashback activated
         */
        hasCashback: boolean;
    }
}

/**
 * Selected app state
 */
export interface StateProps {
    /**
     * App is loading
     */
    isLoading: boolean;
    /**
     * App is in error state
     */
    hasError: boolean;
    /**
     * Customer configuration
     */
    customerConfig: InitialState['customerConfig'];
    /**
     * Red+ offers
     */
    redPlusOffers: SimOnlyOffer<RedplusTariff>[];
    /**
     * Active subscription in VVL flow
     */
    vvlTariffOffer: SimOnlyOffer<RedTariff | YoungTariff> | TariffWithHardwareOffer<RedTariff | YoungTariff> | null;
}
